//Add User login details in redux
export const setUserDetails = (userData) => {
    
    return {
        type: 'SET_USER_DETAILS',
        payload: userData,
    };
};

//Clears all the User login details from redux
export const clearUserDetails = () => {
    return {
        type: 'CLEAR_USER_DETAILS',
    };
};
